import blogr from "../../Images/blogr.webp";
import easybank from "../../Images/easybank.webp";
import imageUploader from "../../Images/imgu.webp";

const Data = [
  {
    name: "Bloggr",
    description: `A Front-end mentor Landing page challenge`,
    image: blogr,
    githubLink: "https://github.com/Rd-Trends/blogr-page",
    liveURL: "https://rd-trends.github.io/blogr-page",
    builtWith: ["Javascript", "HTML5", "CSS3"],
  },
  {
    name: "EasyBank",
    description: `A Front-end mentor Landing page challenge`,
    image: easybank,
    githubLink: "https://github.com/Rd-Trends/easybank-landing-page",
    liveURL: "https://rd-trends.github.io/easybank-landing-page",
    builtWith: ["Javascript", "HTML5", "CSS3"],
  },
  {
    name: "Image Uploader",
    description: `Store images easily and then retrieve it anytime with it's saved url`,
    image: imageUploader,
    githubLink: "https://github.com/Rd-Trends/image-uploader",
    liveURL: " https://image-uploader-aa214.web.app",
    builtWith: ["React JS",  "CSS3", "Firebase",],
  },
];

export default Data;
